import { render } from "./CardIcon.vue?vue&type=template&id=0aeda255&scoped=true"
import script from "./CardIcon.vue?vue&type=script&lang=js"
export * from "./CardIcon.vue?vue&type=script&lang=js"

import "./CardIcon.vue?vue&type=style&index=0&id=0aeda255&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0aeda255"

export default script